module.exports = "/work-site/img/realTime.30054d4e.png";